/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Defines to which device the flag should be sent.
 * @export
 * @enum {string}
 */
export enum FlagCanId {
    ALL_ANTENNAS = 'allAntennas',
    ALL_ANTENNAS_A = 'allAntennasA',
    ALL_ANTENNAS_B = 'allAntennasB',
    ANTENNA_A0 = 'antennaA0',
    ANTENNA_A1 = 'antennaA1',
    ANTENNA_A2 = 'antennaA2',
    ANTENNA_A3 = 'antennaA3',
    ANTENNA_B0 = 'antennaB0',
    ANTENNA_B1 = 'antennaB1',
    ANTENNA_B2 = 'antennaB2',
    ANTENNA_B3 = 'antennaB3'
}


export function instanceOfFlagCanId(value: any): boolean {
    for (const key in FlagCanId) {
        if (Object.prototype.hasOwnProperty.call(FlagCanId, key)) {
            if (FlagCanId[key as keyof typeof FlagCanId] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FlagCanIdFromJSON(json: any): FlagCanId {
    return FlagCanIdFromJSONTyped(json, false);
}

export function FlagCanIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlagCanId {
    return json as FlagCanId;
}

export function FlagCanIdToJSON(value?: FlagCanId | null): any {
    return value as any;
}

export function FlagCanIdToJSONTyped(value: any, ignoreDiscriminator: boolean): FlagCanId {
    return value as FlagCanId;
}

